namespace $ {

	export function $shm_hitalama_map_page_viewport_widget_visible(
		data: Pick< ReturnType< $shm_hitalama_map_widget['render_data'] >,
			'body_x' | 'body_y' | 'right_edge_x' | 'bottom_edge_y' >,
		viewport: { left: number, top: number, right: number, bottom: number },
		overscan = 0,
	) {
		const values = [ data.body_x, data.body_y, data.right_edge_x, data.bottom_edge_y ]
		if( values.some( value => !Number.isFinite( value ) ) ) return true

		return data.body_x + data.right_edge_x >= viewport.left - overscan
			&& data.body_x <= viewport.right + overscan
			&& data.body_y + data.bottom_edge_y >= viewport.top - overscan
			&& data.body_y <= viewport.bottom + overscan
	}

}
